import { render, staticRenderFns } from "./information-card.vue?vue&type=template&id=545d7d94&scoped=true&"
import script from "./information-card.vue?vue&type=script&lang=ts&"
export * from "./information-card.vue?vue&type=script&lang=ts&"
import style0 from "./information-card.vue?vue&type=style&index=0&id=545d7d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d7d94",
  null
  
)

export default component.exports